import type { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { useBusinessNav } from '@/hooks/useBusinessNav';

interface ReportLayoutProps {
  title: string;
  children: ReactNode;
  actions?: ReactNode;
  filters?: ReactNode;
}

export function ReportLayout({ title, children, actions, filters }: ReportLayoutProps) {
  const { nav } = useBusinessNav();

  return (
    <div className="fixed inset-0 z-50 bg-background flex flex-col overflow-hidden">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="flex-1 flex flex-col overflow-hidden"
      >
        {/* Header */}
        <div className="flex items-center gap-3 px-6 py-4 border-b flex-shrink-0">
          <button
            onClick={() => nav('/reports')}
            className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Reports
          </button>
          <div className="flex-1" />
          {actions}
        </div>

        {/* Content area */}
        <div className="flex-1 overflow-y-auto overflow-x-hidden">
          <div className="px-6 py-6">
            {/* Title */}
            <h1 className="text-2xl mb-6">{title}</h1>

            {/* Filters */}
            {filters && (
              <div className="mb-6 flex items-center gap-4 flex-wrap">
                {filters}
              </div>
            )}

            {/* Content */}
            {children}
          </div>
        </div>
      </motion.div>
    </div>
  );
}
